import { Typography, Button, IconButton, LinearProgress } from '@material-ui/core';
import '../../styles/Globales.scss';
import '../../styles/Firmas.scss';
import React, { Component } from 'react';
import { KeyboardBackspaceOutlined } from '@material-ui/icons';
import appStore from '../../stores/AppStore';
import ListaProductoResumenComponent from './ListaProductoResumenComponent';
import ViewConstants from '../../utils/ViewConstants';
import SmsCodigoComponent from '../utils/SmsCodigoComponent';

export default class FirmasComponent extends Component {
  codigoSms;

  constructor(props) {
    super(props);
    this.state = {
      datosCliente: {},
      openPopupSms: false,
    };
  }

  componentDidMount = () => {
    appStore.cargarDatosCliente(this.onCargarDatosResult);
  };

  onCargarDatosResult = (datosCliente) => {
    this.setState({ datosCliente: datosCliente });
  };

  onVolver = () => {
    appStore.changeNavigation(ViewConstants.ETAPA_PRODUCTOS_A_CONTRATAR);
  };

  crearSolicitud = () => {
    appStore.solicitarNuevaPortalidadStore.crearYFirmar(this.codigoSms, appStore.preguntaSeguridadStore.idChallenge, this.onCrearResult, this.onCrearFail);
  };

  onCrearResult = (data) => {
    appStore.changeNavigation(ViewConstants.ETAPA_FINAL_SOLICITUD);
  };

  onCrearFail = () => {};

  generarCertificado = () => {
    if (appStore.solicitarNuevaPortalidadStore.portaTodosSusProductos()) {
      appStore.generateDataLayer({ eventAction: 'step_6', eventLabel: 'todos_confirmacion_descargar' });
    } else {
      appStore.generateDataLayer({ eventAction: 'step_6', eventLabel: 'algunos_confirmacion_descargar' });
    }
    appStore.solicitarNuevaPortalidadStore.generarCertificado(this.state.datosCliente.id, this.onCertificadoOk, this.onCertificadoFail);
  };

  onCertificadoOk = (pdf) => {
    const pdfName = 'data:application/pdf;base64,' + pdf;
    const link = document.createElement('a');
    link.href = pdfName;
    link.setAttribute('download', 'solicitud_portabilidad');
    link.click();
  };

  onCertificadoFail = () => {};

  solicitarCodigSms = () => {
    if (appStore.solicitarNuevaPortalidadStore.portaTodosSusProductos()) {
      appStore.generateDataLayer({ eventAction: 'step_6.1', eventLabel: 'todos_confirmacion_finalizar' });
      appStore.generateDataLayer({ eventAction: 'step_6.2', eventLabel: 'todos_confirmacion_autorizacion' });
    } else {
      appStore.generateDataLayer({ eventAction: 'step_6.1', eventLabel: 'algunos_confirmacion_finalizar' });
      appStore.generateDataLayer({ eventAction: 'step_6.2', eventLabel: 'algunos_confirmacion_autorizacion' });
    }
    this.setState({ openPopupSms: true });
  };
  validarSms = (codigo) => {
    this.codigoSms = codigo;
    this.setState({ openPopupSms: false });
    this.crearSolicitud();
  };

  onClosePoupSms = () => {
    this.setState({ openPopupSms: false });
  };

  toUpperCamel = (value) => {
    let result = '';
    if (value) {
      const splitted = value.split(' ');
      result = splitted.map((item) => {
        return item.charAt(0).toUpperCase() + item.toLowerCase().slice(1);
      });
      result = result.join(' ');
    }
    return result;
  };
  render() {
    return (
      <div className="contenedorPrincipal">
        <div className="paso">
          <div>
            <Typography className="tituloBR">
              <IconButton onClick={this.onVolver}>
                <KeyboardBackspaceOutlined />
              </IconButton>
              Confirmación
            </Typography>
          </div>
        </div>
        <LinearProgress variant="determinate" color="secondary" value={appStore.navigationSection * (100 / ViewConstants.TOTAL_ETAPAS)} className="barraProgreso" />
        <Typography className="tituloDatosPersonales">Tus datos personales son:</Typography>
        <div className="resumenInfo">
          <div>
            <Typography className="tituloInfo">Nombre</Typography>
            <Typography className="info">{this.toUpperCamel(this.state.datosCliente.nombreCompleto)}</Typography>
          </div>
          <div>
            <Typography className="tituloInfo">Rut</Typography>
            <Typography className="info">
              {this.state.datosCliente.rut}-{this.state.datosCliente.dv}
            </Typography>
          </div>
          <div>
            <Typography className="tituloInfo">Mail</Typography>
            <Typography className="info">{this.state.datosCliente.email}</Typography>
          </div>
          <div>
            <Typography className="tituloInfo">Dirección </Typography>
            <Typography className="info">{this.toUpperCamel(this.state.datosCliente.direccionCompleta)}</Typography>
          </div>
          <div>
            <Typography className="tituloInfo">Banco Origen</Typography>
            <Typography className="info">{this.toUpperCamel(appStore.solicitarNuevaPortalidadStore.bancoSeleccionado.nombre)}</Typography>
          </div>
        </div>
        <Typography className="tituloStepSolicitudResumen">
          Estos son los productos que has seleccionado para portar a <strong>Banco Ripley</strong>
        </Typography>
        <div>
          {appStore.solicitarNuevaPortalidadStore.bolsaProductos.map((item, index) => {
            return <ListaProductoResumenComponent key={index} producto={item} />;
          })}
        </div>

        <div className="firma">
          <div className="tituloFirma">
            <Typography className="tituloInfo">Solicitud de Portabilidad</Typography>
            <Button color="primary" className="descargarDoc" onClick={this.generarCertificado}>
              descargar
              <img className="pdf" src={require('../../images/pdfmorado.svg')} alt="pfd" />
            </Button>
          </div>
        </div>
        <div className="botones">
          <Button color="primary" id="btnFinalizar" className="btnRipley" onClick={this.solicitarCodigSms} fullWidth={true}>
            finalizar
          </Button>
        </div>
        <SmsCodigoComponent open={this.state.openPopupSms} onAceptar={this.validarSms} onClose={this.onClosePoupSms} telefono={this.state.datosCliente.celular} />
      </div>
    );
  }
}
